import { ChartService } from "./historical-chart.service";
import { type StablecoinLatestDO } from "../data/pie-chart.data";
import { type BubbleDO } from "../data/bubble.data";

export class BubbleChartService {
  constructor(private chartService: ChartService) { }

  async loadBubbleDefiTradfiTVL(): Promise<BubbleDO> {
    return this.chartService.load("bubble_defi_vs_tradfi_tvl");
  }

  async loadStablecoinVsBanks(): Promise<StablecoinLatestDO> {
    return this.chartService.load('stablecoins');
  }

  async loadRwaPrivateCreditComparativeBubble(): Promise<BubbleDO> {
    return this.chartService.load('rwa_private_credit_comparative_bubble');
  }

  async loadRwaMoneyMarketFundsComparativeBubble(): Promise<BubbleDO> {
    return this.chartService.load('rwa_money_market_funds_comparative_bubble');
  }
}
